// The client side of /api/dossiers (BUILD-BRIEF-R2 §9) — owned by the `research` agent.
import { qs, request } from './client.js';
import type { Dossier, ListResponse, SubjectKind } from '../../shared/types.js';

/** A dossier as the route returns it: citations resolved to the snapshot's url and fetch date,
 *  the run's ref beside its id. */
export interface DossierView extends Dossier {
  run_ref?: string | null;
}

/** The latest version for a subject, with `version_count` beside it. Null when nobody has
 *  looked yet — DossierZone then says so in words rather than showing an empty document. */
export function latestDossier(subjectKind: SubjectKind, subjectId: number): Promise<DossierView | null> {
  return request(`/dossiers${qs({ subject_kind: subjectKind, subject_id: subjectId, latest: '1' })}`);
}

export function listDossiers(subjectKind: SubjectKind, subjectId: number): Promise<ListResponse<DossierView>> {
  return request(`/dossiers${qs({ subject_kind: subjectKind, subject_id: subjectId })}`);
}

export function getDossier(id: number): Promise<DossierView> {
  return request(`/dossiers/${id}`);
}
